<template>
  <el-dialog class="dialog-import-module" :visible.sync="showFlag" :width="importInfo.width" :show-close='false' :before-close="closeImport" top='30vh' v-loading="importLoading" destroy-on-close>
    <h-module-head slot="title" :titleInfo="importInfo.titleInfo" iconEl="el-icon-close" borderB='1px solid #EFEFEF' @clickEvent="closeImport"></h-module-head>
    <div class="dialog-import-content">
      <div class="dialog-import-template" @click="downTemplate" v-if="importInfo.downTemplateFlag">
        <i class="el-icon-paperclip"></i>
        <span>下载模板</span>
      </div>
      <div class="dialog-import-upload">
        <div class="dialog-import-upload-body">
          <input type="file" @change="fileChange" accept=".xls,.xlsx" class="dialog-import-true-upload-file" />
          <div class="dialog-import-upload-file">
            <i class="el-icon-upload" style="font-size: 25px"></i>
            <div class="dialog-import-chioce-file">{{this.fileInfo? this.fileInfo.name:'点击上传'}}</div>
          </div>
        </div>
      </div>
      <div class="dialog-import-prompt" v-if="importInfo.promptInfo">
        {{importInfo.promptInfo}}
      </div>
      <div class="dialog-import-error" v-if="importInfo.errorFlag && tableData.length >0">
        <div>上传表格错误信息</div>
        <el-table :data="tableData" stripe style="margin-top:20px" height="300">
          <el-table-column v-for="(item,i) in importInfo.columnList" :prop="item.prop" :label="item.label" :key="i" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="dialog-import-but">
        <button class="bottom-cancel-button" style="margin-right: 16px;" @click="closeImport">取消</button>
        <button class="bottom-sure-button" @click="submitImport">确定</button>
      </div>
    </div>
  </el-dialog>

</template>
<!--  
importInfo:{
  titleInfo:'',//标题
  width:'40%',//弹窗整体宽度
  downTemplateFlag:true,//是否展示下载模板按钮
  downTemplateApi:'',//下载模板链接
  promptInfo:'',//提示语
  errorFlag:false,//是否展示导入的错误数据
  columnList:[],//若是有错误数据且显示，配置table字段
  submitImportApi:'',//提交函数
  submitDealFun:function,//处理提交后返回的数据的函数，可不传
}
showFlag:true,
close:function
-->
<script>
import hModuleHead from './h-module-head.vue'
export default {
  props: {
    showFlag: { type: Boolean, default: false },
    importInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { hModuleHead },
  mounted() {},
  data() {
    return {
      importLoading: false,
      fileInfo: '',
      tableData: [],
    }
  },
  watch: {},
  methods: {
    downTemplate() {
      if (this.importInfo['downTemplateApi']) {
        let data = {}
        this.$API[this.importInfo['downTemplateApi']](data).then((res) => {
          console.log(res)
          if (res.code == '10000') {
            window.location.href = res.data.tempUrl
            console.log('res', res)
          }
        })
      }
      if (this.importInfo['downTemplateLink']) {
        window.location.href = this.importInfo['downTemplateLink']
      }
    },
    closeImport() {
      this.fileInfo = ''
      this.tableData = []
      this.$emit('close')
    },
    fileChange(e) {
      this.tableData = []
      this.fileInfo = e.target.files[0]
    },
    submitImport() {
      let data = new FormData()
      if (!this.fileInfo) {
        this.$message({
          message: '请选择上传的文件',
          type: 'warning',
        })
        return
      }
      this.importLoading = true
      data.append(this.importInfo['dataParam'], this.fileInfo)
      this.$API[this.importInfo['submitImportApi']](data).then(
        (res) => {
          console.log(res)

          if (res.failureDetails.length == 0) {
            this.$message({
              message: '上传成功！',
              type: 'success',
            })
            this.importLoading = false
            this.closeImport()
          } else {
            this.tableData = this.importInfo['dealData'](res.failureDetails)
            this.importLoading = false
          }
        },
        (err) => {
          this.importLoading = false
        }
      )
    },
  },
}
</script>

<style lang="less">
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.dialog-import-module {
  .dialog-import-content {
    width: 100%;
    padding: 22px 30px;
    .dialog-import-template {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #222222;
    }

    .dialog-import-upload {
      padding: 2px;

      .dialog-import-upload-body {
        height: 54px;
        position: relative;
        border: 1px dashed #d0d0d0;
        border-radius: 5px;
        .dialog-import-true-upload-file {
          z-index: 998;
          width: 100%;
          height: 54px;
          opacity: 0;
          cursor: pointer;
        }

        .dialog-import-upload-file {
          .displayFlex;
          position: relative;
          top: -54px;
          height: 54px;
          cursor: pointer;
          color: #17A48B;
          font-size: 18px;
          pointer-events: none;
          .dialog-import-chioce-file {
            margin-left: 10px;
          }
        }
      }
      .dialog-import-upload-body:hover {
        border: 1px solid #17A48B;
      }
    }
    .dialog-import-prompt {
      color: #168bcf;
      font-size: 16px;
      margin-top: 15px;
    }

    .dialog-import-but {
      .displayFlex;
      justify-content: flex-end;
      height: 110px;
      align-items: flex-end;
    }
  }

  .dialog-import-status-content {
    width: 100%;
    padding: 22px 30px;
  }
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-select {
    width: calc(100%) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-import-dialog.vue